module.exports = __webpack_public_path__ + "static/img/btn_xiaoyouzhijia_nor.0284193.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_xiaoyouzhijia_nor.png
// module id = cm8A
// module chunks = 1